import { Module } from 'vuex';
import { RootState } from '@/store/state';
import { getters } from './getters';
import { mutations } from './mutations';
import state from './state';

const ui: Module<typeof state, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters
};
export default ui;
